import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputLabel,
  CircularProgress,
  Modal,
  Select,
  MenuItem,
  FormControl,

} from "@mui/material";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
import { useUserAdmin } from "../../../../admin/UserContext";
import { IoClose } from "react-icons/io5";

const coloresDisponibles = [
  "#1A425B",
  "#FFFFFF",
  "#00A69E",
  "#6A3090",
  "#FFA457",
];

export const CrearServicioInicio = ({onclose, fetchSliders}) => {
    const { Token} = useUserAdmin();
    const [loading, setLoading] = useState(false);
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
  const [formData, setFormData] = useState({
    icono: null,
    imagen_icono: null,
    imagen_icono2: null,
    titulo: "",
    titulo1: "",
    descripcion: "",
    descripcion1: "",
    color: "",
    orden: ""
  });


  const handleFileChange = (e, name) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, [name]: file }));
  };

  const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

 const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviandoAlert(true)
    const data = new FormData();
    data.append("icono", formData.icono);
    data.append("imagen_icono", formData.imagen_icono);
    data.append("imagen_icono2", formData.imagen_icono2);
    data.append("titulo", formData.titulo); 
    data.append("titulo1", formData.titulo1);  
    data.append("descripcion", formData.descripcion); 
    data.append("descripcion1", formData.descripcion1);
    data.append("color", formData.color);
    data.append("orden", formData.orden);


    try {
      setLoading(true);
      await axios.post(`${backendURL}/api/servicio/home`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      setAlertMessage("Se ha generado con éxito.");
      setEnviandoAlert(false)
      setSuccessAlertOpen(true);
      
    
    } catch (error) {
      console.error(error);
      setAlertMessage("Error al crear.");
      setErrorAlertOpen(true);
       setEnviandoAlert(false)
    } finally {
      setLoading(false);
      await fetchSliders()
      setTimeout(() => {
        setSuccessAlertOpen(false);
         setEnviandoAlert(false)
        setErrorAlertOpen(false);
        onclose();
       
      }, 3000);
    }
  };

   const renderPreview = (file) =>
    file ? (
      <img
        src={URL.createObjectURL(file)}
        alt="preview"
        style={{
          width: "100%",
          maxWidth: "250px",
          height: "auto",
          marginBottom: "10px",
          borderRadius: "8px",
          border: "2px solid #585857",
        }}
      />
    ) : null;

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Crear Nuevo Slider
      </Typography>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Icono</InputLabel>
         {renderPreview(formData.icono)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "icono")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
         <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen icono</InputLabel>
         {renderPreview(formData.imagen_icono)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "imagen_icono")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen icono uno</InputLabel>
         {renderPreview(formData.imagen_icono2)}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "imagen_icono2")}
            style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo</InputLabel>
         
          <input
            name="titulo"
            label="Título"
            value={formData.titulo}
            onChange={handleInputChange}
            style={{ border: "2px solid #585857",  color:'#585857', background:'#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo dos</InputLabel>
         
          <input
            name="titulo1"
            label="Título"
            value={formData.titulo1}
            onChange={handleInputChange}
            style={{ border: "2px solid #585857",  color:'#585857', background:'#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Descripción</InputLabel>
         
          <input
           name="descripcion"
          label="Descripción"
          value={formData.descripcion}
          onChange={handleInputChange}
            style={{ border: "2px solid #585857",  color:'#585857', background:'#fff',padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        <div>
          <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Descripción dos</InputLabel>
         
          <input
           name="descripcion1"
          label="Descripción"
          value={formData.descripcion1}
          onChange={handleInputChange}
            style={{ border: "2px solid #585857",  color:'#585857', background:'#fff',padding: "8px", borderRadius: "6px", width: "100%" }}
          />
        </div>
        
         <FormControl
  fullWidth
  sx={{
    border: "2px solid #585857",
    borderRadius: "6px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  }}
>
  <InputLabel id="color-select-label">Color</InputLabel>
  <Select
    labelId="color-select-label"
    name="color"
    type="color"
     value={formData.color} 
    onChange={handleInputChange}
    renderValue={(selected) => selected} 
  >
    {coloresDisponibles.map((color) => (
      <MenuItem
        key={color}
        value={color}
        sx={{
          backgroundColor: formData.color === color ? "#e0e0e0" : "#fff",
          color: "#585857",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
     
        {color}
      </MenuItem>
    ))}
  </Select>
</FormControl>
        
        {formData.color && (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      mt: 1,
    }}
  >
    <Typography variant="body1" sx={{color:'#585857'}}>Este es el color seleccionado:</Typography>
    <Box
      sx={{
        width: 200,
        height: 24,
        backgroundColor: formData.color,
        border: '1px solid #000',
        borderRadius: '4px',
      }}
    />
    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
      {formData.color}
    </Typography>
  </Box>
)}

        <TextField
          label="Posición"
          name="orden"
          type="number"
          value={formData.orden}
          onChange={handleInputChange}
          inputProps={{ min: 1 }}
          sx={{
            '& .MuiInputBase-input': {
                color: '#585857', // Color del número (input)
                },
                '& .MuiInputLabel-root': {
                color: '#585857', // Color del label
                },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                color:'#585857',
                borderColor: '#585857'
              },
              '&:hover fieldset': {
                borderColor: '#585857'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#585857'
              }
            }
          }}
        />

        <Button
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: "#5E487B",
            color: "#fff",
            textTransform: "capitalize"
          }}
          type="submit"
        >    {loading ? <CircularProgress size={24} /> : 'Guardar'}
          
        </Button>
      </form>

       <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose style={{color:'#585857'}}/>
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de error */}
            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center' }}>
                        <BiErrorCircle style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
                        <p>{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            {/* Modal de progreso */}
            <Modal open={enviandoAlert} onClose={() => setEnviandoAlert(false)}>
                <Box sx={modalStyle}>
                <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: 'center', padding: '1rem' }}>
                        <CircularProgress style={{ color: '#694B81' }} />
                        <p>Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
    </Box>
  );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#ffff',
    border: '0px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'10px'
  };
